import React, { memo, useState } from 'react';
import { View, Text, StyleSheet, Pressable, Image } from 'react-native';
import { Container, CTAButton } from '../../components';
import { COLOR, FONT, FONT_SIZE, THEME, __WEB__ } from '../../../constants/styles';

const flyImage = require('../../../../resources/appt_types/icon-fly-pha-cmr.png');
const nonFlyImage = require('../../../../resources/appt_types/icon-non-fly-pha-cmr.png');

import { EVENT_TYPE_CMR, EVENT_TYPE_CMR_FLY } from '../../../constants/eventTypes';

import AppointmentPreReqs from './appointment_prereqs.js';

const FlyNonFlyButton = memo((props) => {
  const [isHovered, setIsHovered] = useState(false);

  function handleMouseIn() {
    setIsHovered(true);
  }

  function handleMouseOut() {
    setIsHovered(false);
  }
  return (
    <View
      style={[
        styles.buttonOuter,
        props.fly ? { marginRight: 5 } : { marginLeft: 5 },
        props.isVerticalLayout ? styles.buttonOuterVertical : styles.buttonOuterHorizontal,
      ]}
    >
      <Pressable
        style={[
          styles.button,
          props.isVerticalLayout ? styles.buttonVertical : styles.buttonHorizontal,
          isHovered ? styles.buttonHover : {},
          props.selected ? styles.buttonSelected : {},
        ]}
        onPress={props.onPress}
        onHoverIn={handleMouseIn}
        onHoverOut={handleMouseOut}
      >
        <Image
          source={props.fly ? flyImage : nonFlyImage}
          style={[styles.buttonImage, props.isVerticalLayout ? styles.buttonImageVertical : null]}
          resizeMode="contain"
        />
        <View>
          <Text style={styles.buttonText}>{props.fly ? 'FLYER' : 'NON-FLYER'}</Text>
          <Text style={styles.buttonSubText}>{props.fly ? '2992 FORM' : 'NO 2992 FORM'}</Text>
        </View>
      </Pressable>
      {!!props.selected && (
        <View
          style={[
            styles.buttonCheck,
            props.isVerticalLayout ? styles.buttonCheckVertical : styles.buttonCheckHorizontal,
          ]}
        >
          <Image style={styles.checkIcon} source={require('../../../../resources/check.png')} />
        </View>
      )}
    </View>
  );
});

const CMRReqStep1 = memo((props) => {
  const [selectedButton, setSelectedButton] = useState(null);
  const [preReqsValid, setPreReqsValid] = useState(false);
  const isVerticalLayout = props.isVerticalLayout;
  const handleFlyPress = () => {
    setSelectedButton('fly');
  };
  const handleNonFlyPress = () => {
    setSelectedButton('non-fly');
  };
  const next = () => {
    props.onCMRTypeSelected(selectedButton === 'fly' ? EVENT_TYPE_CMR_FLY : EVENT_TYPE_CMR);
  };

  return (
    <Container>
      <Text style={styles.contentTitle}>CMR Appointment</Text>
      <View style={{ alignItems: 'center' }}>
        <View
          style={[
            styles.content,
            isVerticalLayout ? styles.contentVertical : styles.contentHorizontal,
          ]}
        >
          <Text style={styles.contentText}>
            David Grant Medical Center’s{' '}
            <Text style={styles.contentTextBold}>Continuous Medical Readiness</Text> process aims to
            streamline your readiness requirements completing all required Individual Medical
            Readiness appointments in <Text style={styles.contentTextBold}>a single day</Text>.
          </Text>
          <Text style={styles.contentText}>
            Please <Text style={styles.contentTextBold}>arrive at 07:30</Text> at the{' '}
            <Text style={styles.contentTextBold}>CMR Cell</Text> and plan on spending your duty day
            at the MDG on the day of your CMR appointment.
          </Text>

          <View style={styles.headerContainer}>
            <Text style={styles.headerText}>
              In order to help provide the best experience, please identify yourself:
            </Text>
          </View>

          <View style={styles.buttonsContainer}>
            <FlyNonFlyButton
              selected={selectedButton === 'fly'}
              isVerticalLayout={isVerticalLayout}
              fly={true}
              onPress={handleFlyPress}
            />
            <FlyNonFlyButton
              selected={selectedButton === 'non-fly'}
              isVerticalLayout={isVerticalLayout}
              fly={false}
              onPress={handleNonFlyPress}
            />
          </View>

          {!!selectedButton && (
            <>
              <View style={[styles.headerContainer, { marginTop: 0, marginBottom: 30 }]}>
                <Text style={styles.headerText}>
                  Your appointment will be rejected if you haven't done the following:
                </Text>
              </View>
              <View style={{ alignItems: 'center' }}>
                <AppointmentPreReqs
                  eventType={selectedButton === 'fly' ? EVENT_TYPE_CMR_FLY : EVENT_TYPE_CMR}
                  onPreReqsChecked={setPreReqsValid}
                  isVerticalLayout={props.isVerticalLayout}
                />
              </View>
            </>
          )}
        </View>
      </View>
      <View style={[{ alignItems: 'center', marginBottom: 25, marginTop: 10 }]}>
        <CTAButton
          style={{ width: 200 }}
          onPress={next}
          label={'Continue'}
          disabled={!preReqsValid}
        />
      </View>
    </Container>
  );
});

const styles = StyleSheet.create({
  contentTitle: {
    ...FONT.medium,
    color: COLOR.text,
    fontSize: FONT_SIZE.huge,
    marginTop: 25,
    textAlign: 'center',
    letterSpacing: 3,
  },
  content: {},
  contentVertical: {},
  contentHorizontal: {
    maxWidth: 800,
    borderWidth: 2,
    borderColor: 'rgb(236, 236, 236)',
    borderRadius: 10,
    margin: 25,
  },
  contentText: {
    ...FONT.regular,
    fontSize: FONT_SIZE.medium,
    margin: 15,
    lineHeight: 22,
  },
  contentTextBold: {
    ...FONT.bold,
  },
  headerContainer: {
    backgroundColor: 'rgb(241, 241, 241)',
    padding: 15,
    borderColor: 'rgb(228, 228, 228)',
    borderTopWidth: 2,
    borderBottomWidth: 2,
    marginTop: 15,
  },
  headerText: {
    ...FONT.bold,
  },
  buttonsContainer: {
    // alignSelf: 'center',
    justifyContent: 'center',
    // maxWidth: 470,
    paddingVertical: 25,
    // paddingHorizontal: 6,
    flexDirection: 'row',
    // backgroundColor: 'red'
    paddingRight: 12,
    paddingLeft: 12,
  },
  buttonOuter: {
    flex: 1,
    // backgroundColor: 'pink',
    padding: 2,
  },
  buttonOuterHorizontal: {
    maxWidth: 300,
    marginTop: 20,
    marginVertical: 20,
    padding: 15,
    // backgroundColor: 'pink'
  },
  buttonOuterVertical: {
    maxWidth: 230,
    // marginHorizontal: 5,
  },
  button: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    borderColor: 'rgb(227, 227, 227)',
    borderWidth: 2,
    // marginHorizontal: 20,
    borderRadius: 8,
    paddingVertical: 10,
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
  },
  buttonCheck: {
    backgroundColor: 'rgb(67, 151, 199)',
    width: 32,
    height: 32,
    borderRadius: 16,
    position: 'absolute',
    top: -7,
    right: -7,
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonCheckHorizontal: {
    width: 40,
    height: 40,
    borderRadius: 20,
    top: -1,
    right: -1,
  },
  buttonHover: {
    borderColor: 'rgb(67, 151, 199)',
    boxShadow: 'none',
  },
  buttonSelected: {
    borderColor: 'rgb(67, 151, 199)',
    boxShadow: 'none',
  },
  buttonHorizontal: {
    paddingLeft: 25,
  },
  buttonVertical: {
    paddingVertical: 5,
  },
  buttonImage: {
    width: 50,
    height: 50,
    margin: 12,
    marginBottom: 15,
    tintColor: 'rgb(44, 66, 107)',
  },
  buttonImageVertical: {
    width: 40,
    height: 40,
    margin: 12,
    marginBottom: 15,
  },
  // buttonImageNonFlyer: {
  //   width: 50,
  //   height: 50,
  //   tintColor: 'rgb(44, 66, 107)',
  // },
  // buttonImageNonFlyerVertical: {
  //   width: 53,
  //   height: 53,
  // },
  buttonText: {
    ...FONT.semibold,
    fontSize: 16,
  },
  buttonSubText: {
    ...FONT.regular,
    fontSize: 14,
  },
  checkIcon: {
    width: 15,
    height: 15,
    tintColor: 'white',
  },
});

export default CMRReqStep1;
